import { Directive, HostListener, Input } from '@angular/core';
import { LayoutNavigationExtra, LayoutRoute, LayoutService } from 'src/app/_core/services/layout.service';

@Directive({
    selector: '[appLayoutLink]',
    standalone: false
})
export class LayoutLinkDirective {

    @Input() appLayoutLink: [LayoutRoute, LayoutNavigationExtra];

    constructor(private layoutService: LayoutService) {
    }

    @HostListener('click', ['$event'])
    navigate($event: MouseEvent): void {
        $event.stopPropagation();
        if (this.appLayoutLink) {
            this.layoutService.navigate(...this.appLayoutLink);
        }
    }
}
